var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auditor",
    transform: "translate(-34.314 -510.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User_Management",
    "data-name": "User Management",
    transform: "translate(34 510)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8125",
    "data-name": "Rectangle 8125",
    width: 26,
    height: 25,
    transform: "translate(0.314 0.338)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16279",
    "data-name": "Group 16279",
    transform: "translate(2.584 2.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16280",
    "data-name": "Group 16280",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10035",
    "data-name": "Path 10035",
    d: "M19.061,44.573h.478c2.631,0,5.262,0,7.893-.006a.543.543,0,0,1,.605.351,9.325,9.325,0,0,0,.615,1.03c-.159.007-.279.017-.4.017H18.645c-.754,0-.971-.2-.952-.954a21.85,21.85,0,0,1,.142-3.147A8.965,8.965,0,0,1,23.357,34.9c.156-.07.316-.129.472-.2.019-.008.029-.034.062-.074-.105-.084-.212-.165-.315-.251A5.418,5.418,0,0,1,25.7,24.858a5.446,5.446,0,0,1,6.685,4.393,5.335,5.335,0,0,1-1.743,4.925,5.27,5.27,0,0,1-3.758,1.39,7.876,7.876,0,0,0-7.706,6.726c-.1.731-.079,1.48-.117,2.282M31.039,30.129a4.061,4.061,0,1,0-4.073,4.042,4.041,4.041,0,0,0,4.073-4.042",
    transform: "translate(-17.692 -24.691)",
    fill: "#7c7c7c",
    stroke: "#fff",
    strokeWidth: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16760",
    "data-name": "Group 16760",
    transform: "translate(47.418 522.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16761",
    "data-name": "Group 16761",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10255",
    "data-name": "Path 10255",
    d: "M21.585,25.987A5.307,5.307,0,1,1,22.579,25a.793.793,0,0,1,.148.1q1.073,1.068,2.142,2.14a.714.714,0,0,1-.925,1.089c-.11-.093-.209-.2-.311-.3l-2.011-2.01a.368.368,0,0,0-.037-.026m-3.217-.359a3.873,3.873,0,1,0-3.86-3.879,3.861,3.861,0,0,0,3.86,3.879",
    transform: "translate(-13.075 -16.454)",
    fill: "#7c7c7c",
    stroke: "#fff",
    strokeWidth: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditor);
export default __webpack_public_path__ + "static/media/Auditor.8659a7416ff45f6b4be2ef8f13fbb0c0.svg";
export { ForwardRef as ReactComponent };